var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarHome = function SvgBottombarHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16.25h-4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.713c0-5.631-.64-5.238-4.088-8.303C16.403 4.246 14.056 2 12.029 2c-2.026 0-4.42 2.235-5.942 3.41C2.64 8.475 2 8.082 2 13.713 2 22 4.044 22 12 22s10 0 10-8.287",
    clipRule: "evenodd"
  })));
};
export default SvgBottombarHome;